import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
import { RESPONDENT_VALID_CUSTOM_FIELDS } from "../constants/index.js";
import { allowedUserProfileFuncParams } from "./survey.js";
import { validDMYFormats } from "./date.js";
dayjs.extend(customParseFormat);
export const RESPONDENT_DATA_VARIABLE = "respondentData";
export const USER_PROFILE_DATA_VARIABLE = "userProfileData";
const allowedRespondentParams = [
    "firstName",
    "lastName",
    "fullName",
    "indigenousStatus",
    "dateOfBirth",
    "developmentalAge",
    "sex",
    "contactEmail",
    "contactMobilePhone",
    "emailAddress",
    "company",
    ...RESPONDENT_VALID_CUSTOM_FIELDS,
];
export const respondentFunction = function respondentFunction(params) {
    if (!params || !Array.isArray(params) || params.length < 1) {
        return null;
    }
    if (!allowedRespondentParams.includes(params[0])) {
        console.warn(`Respondent function called with invalid parameter: ${params[0]}`);
        return null;
    }
    const respondent = this.survey?.getVariable(RESPONDENT_DATA_VARIABLE);
    if (respondent &&
        typeof respondent === "object" &&
        Object.keys(respondent).length > 0) {
        if (params[0] === "fullName") {
            return `${respondent.firstName} ${respondent.lastName}`.trim();
        }
        if (params[0] === "company") {
            return respondent.company?.name;
        }
        if (params[0] in respondent) {
            const respondentParam = respondent[params[0]];
            // If a date is in a valid format, convert it to YYYY-MM-DD for consistency, otherwise return as is (could be a string or other type)
            if (typeof respondentParam === "string" &&
                validDMYFormats.some((format) => dayjs(respondentParam, format, true).isValid())) {
                return dayjs(respondentParam, validDMYFormats, true).format("YYYY-MM-DD");
            }
            return respondentParam;
        }
    }
    return null;
};
export const userProfileFunction = function userProfileFunction(params) {
    if (!params || !Array.isArray(params) || params.length < 1) {
        return null;
    }
    if (!allowedUserProfileFuncParams.includes(params[0])) {
        console.warn(`User profile function called with invalid parameter: ${params[0]}`);
        return null;
    }
    const userProfileData = this.survey?.getVariable(USER_PROFILE_DATA_VARIABLE);
    if (userProfileData &&
        typeof userProfileData === "object" &&
        Object.keys(userProfileData).length > 0) {
        if (params[0] === "fullName") {
            return `${userProfileData.firstName} ${userProfileData.lastName}`.trim();
        }
        if (params[0] in userProfileData) {
            return userProfileData[params[0]];
        }
    }
    return null;
};
// Registers the respondent() and userProfile() custom expression functions so surveys can use them in their logic.
// Registration is global, data is read from the survey model's variables (RESPONDENT_DATA_VARIABLE / USER_PROFILE_DATA_VARIABLE).
export const registerSurveyCustomFunctions = (FunctionFactoryInstance) => {
    FunctionFactoryInstance.register("respondent", respondentFunction);
    FunctionFactoryInstance.register("userProfile", userProfileFunction);
};
//# sourceMappingURL=survey-custom-functions.js.map